var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1396.6194,
    y1: 250.3259,
    x2: 1736.861,
    y2: 250.3259,
    gradientTransform: "matrix(-1 0 0 1 1817.2345 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002180233,
    style: {
      stopColor: "#009EE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7DB828"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.84,242.4V116.62h125.78v109.42c0,37.15-2.91,65.96-8.69,86.41c-5.78,20.45-18.06,37.25-36.82,50.37 c-18.76,13.11-45.51,20.2-80.27,21.22v-53.17c40.9-6.14,61.36-31.52,61.36-76.18V242.4H294.84z M80.37,242.4V116.62h125.78v109.42 c0,37.15-2.83,65.96-8.45,86.41c-5.66,20.45-17.97,37.25-36.97,50.37c-19,13.11-45.78,20.2-80.35,21.22v-53.17 c40.9-6.14,61.35-31.52,61.35-76.18c0-2.73-0.16-6.82-0.51-12.27H80.37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteRight);
export default __webpack_public_path__ + "static/media/quote_right.5fa23f4491b6209c71976f0e6810bf50.svg";
export { ForwardRef as ReactComponent };